// Modules
// Material-ui
import { styled } from '@mui/material/styles';
import Button, { buttonClasses } from '@mui/material/Button';

// Helpers
import { COLORS } from '@/lib/helpers';

// Components
// Common components

const SecondaryButton = styled(Button)(({ theme }) => ({
  padding: '0.375rem 0.75rem',
  borderRadius: '2px',
  color: COLORS.BLACK,
  backgroundColor: COLORS.WHITE,
  border: `1px solid ${COLORS.BORDER_MAIN}`,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: COLORS.WHITE,
    border: `1px solid ${theme.mainColor}`,
    color: theme.mainColor,
  },
  '&.MuiButton-sizeSmall': {
    padding: '0.25rem 0.5rem',
  },
  '&.MuiButton-sizeLarge': {
    padding: '0.5rem 1rem',
  },
  '&.Mui-disabled': {
    color: COLORS.GRAY_SHADE_40,
    '& .MuiButton-startIcon, & .MuiButton-endIcon': {
      color: `${COLORS.GRAY_SHADE_40} !important`,
    },
  },
  [`& .${buttonClasses.startIcon}`]: {
    color: theme.mainColor,
  },
  [`& .${buttonClasses.endIcon}`]: {
    color: theme.mainColor,
  },
  '&.Mui-focusVisible': {
    outline: `solid ${theme.mainColor}`,
    outlineOffset: '2px',
  },
  '&.MuiButton-textError': {
    color: COLORS.ERROR,
    border: `1px solid ${COLORS.ERROR}`,
    '& .MuiButton-startIcon, & .MuiButton-endIcon': {
      color: `${COLORS.ERROR} !important`,
    },
    '&:hover': {
      backgroundColor: COLORS.ERROR_BG,
    },
  },
}));

export default SecondaryButton;
